module.exports = __webpack_public_path__ + "static/solutions-module-develop-b9e5b39054a4d06b2200493d722ca5a8.svg";